export default __webpack_public_path__ + "assets/eb89f75ac2658171bcc6734e69b56656.svg";